import UpcomingFeaturedEvents from './upcoming-featured-events'

export default UpcomingFeaturedEvents
